Dates = require 'lib/dates'
MemberCardsCardView = require 'views/card/member-cards-card-view'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'

module.exports = class MemberCardsDateSectionView extends View
  className: 'window-module'

  initialize: ({ @templateData }) ->

  render: ->
    data =
      iconType: 'clock'
      isOverdue: false
      isDueSoon: false

    _.extend(data, @templateData)

    if @groupedCards.length > 0

      @$el.html(
        templates.fill(
          'member_cards_date',
          data
        )
      )

      @renderCards()

    else
      @$el.empty()

    @

  renderCards: ->
    views = @groupedCards.map (card) =>
      @subview(MemberCardsCardView, card, { showBoard: true })

    @appendSubviews(views, @$('.js-list'))



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-cards-date-section-view.coffee